module.exports = __webpack_public_path__ + "img/L1A.dc717785.jpg";